import CompanyDetailsModel from "js/models/company.details.model";
import CompanyDetailsPartialTemplate from 'js/templates/company.details.hbs';
import GenericView from 'js/views/generic.view';
import i18n from "l10n";
import countriescode from "countriescode";
import {el, model, on, template} from "../adapters/backbone-decorators";

@el("#company-details-container")
@model(CompanyDetailsModel)
@template(CompanyDetailsPartialTemplate)
class CompanyDetailsView extends GenericView {
    constructor() {
        super();
        this.loadCompanyDetails().then(() => console.log("Loaded company details."));
    }

    async loadCompanyDetails() {
        try {
            await this.model.fetch();
        } catch (error) {
            console.error(error.statusText);
        }
        const curCountry = this.model.get("country");
        const countryName = countriescode.alphaToCountry(curCountry);
        this.model.set("countryName", countryName);

        try {
            await this.fetchPendingConfirmation();
        } catch (e) {
            console.error("Failed to fetch pending confirmation", e);
        }

        this.render();
    }

    async fetchPendingConfirmation() {
        try {
            const {status, pendingConfirmationEmail} = await $.ajaxDefaultQ({
                url: '/CampaignCloud/CompanyDetails/EmailChangeRequest/PendingEmailChangeRequestConfirmation',
                type: 'POST',
                dataType: "json"
            });
            if (status === 'success') {
                this.model.set("pendingConfirmationEmail", pendingConfirmationEmail);
            } else {
                console.info(`There is not pending request for email change!`);
            }
        } catch (error) {
            console.error(error);
        }
    }

    updateCallback(attributeName, value, outcome, e, settings) {
        if ($(e).hasClass("select")) {
            $(e).text(countriescode.alphaToCountry(value));
            const spriteel = $(e).prev("i");
            spriteel.removeClass();
            spriteel.addClass("flag-icon");
            spriteel.addClass(`flag-icon-${value.toLowerCase()}`);
        }
        return super.updateCallback(attributeName, value, outcome, e, settings);
    }

    handleUpdate(value, settings, e) {
        if ($(e).hasClass('email')) {
            this.submitNewEmail(value);
            value = this.model.get('email');
        }
        return super.handleUpdate(value, settings, e);
    }

    getCountries() {
        return countriescode.getCountries();
    }

    countryNameToAlpha(name) {
        return countriescode.countryNameToAlpha(name);
    }

    inputIsValid(e, input) {
        const message = $(e).parent().next("span");
        message.hide();
        $(input).removeClass("invalid").addClass("valid");
    }

    inputIsInvalid(e, input) {
        const message = $(e).parent().next("span");
        message.show();
        $(input).removeClass("valid").addClass("invalid");
    }

    inputSubmit(input) {
        if(!input.hasClass('valid'))
            return false;
    }

    inputBlur(e) {
        const message = $(e).parent().next("span");
        message.hide();
    }

    numberIsValid(e, input, c) {
        const spriteel = this.$el.find('#countryFlag');
        spriteel.removeClass();
        spriteel.addClass("flag-icon");
        this.$el.find('.icon-warning').remove();
        const $msisdn = $('#contactPhoneError');
        $msisdn.hide();
        if (c) {
            spriteel.addClass(`flag-icon-${c.toLowerCase()}`);
            this.$el.find('#country-code').text(` ${c} `);
        }
        $(input).removeClass("invalid").addClass("valid");
        this.$el.find("button[type=submit]").removeAttr("disabled");
    }

    numberIsInvalid(e, input) {
        const spriteel = this.$el.find('#countryFlag');
        spriteel.removeClass();
        spriteel.addClass("icon-warning fg-darkRed");
        this.$el.find('#country-code').text('');
        const $msisdn = $('#contactPhoneError');
        $msisdn.show();
        $(input).removeClass("valid").addClass("invalid");
        this.$el.find("button[type=submit]").attr("disabled", "disabled");
    }

    numberBlur(e, c, input) {
        const message = $(e).parent().next("span");
        message.hide();
        if ($(e).hasClass('msisdn')) {
            const spriteel = this.$el.find('#countryFlag');
            spriteel.removeClass();
            spriteel.addClass("flag-icon");
            const $country = this.$el.find('#country-code');
            $country.text('');
            this.$el.find('.icon-warning').remove();
            if (c) {
                spriteel.addClass(`flag-icon-${c.toLowerCase()}`);
                $country.text(` ${c} `);
            } else {
                $(input).parent().parent().parent().find("#countryFlag").removeClass();
            }
            $(input).removeClass("invalid").addClass("valid");
        }
        const val = input[0].value;
        if (!val || !$(input).hasClass("valid")) {
            $(input).parent().parent().parent().find("#countryFlag").removeClass();
            $(input).parent().parent().parent().find('#country-code').text('');
        }
    }

    numberSubmit(input) {
        const val = input[0].value;
        if (!val) {
            $(input).parent().parent().parent().find("#countryFlag").removeClass();
            $(input).parent().parent().parent().find('#country-code').text('');
            return true;
        }
        if (!input.hasClass('valid')) {
            return false;
        }
    }

    /* Fishy area, hide it under the carpet until they find out */
    emailIsValid(e, input) {
        const email = input[0].value;
        if (email) {
            $(e).find("button[type=submit]").removeAttr("disabled");
            const message = $(e).parent().next("span");
            message.hide();
            $(input).removeClass("invalid").addClass("valid");
        } else {
            this.emailIsInvalid(e, input);
        }
    }

    emailIsInvalid(e, input) {
        const email = input[0].value;
        if (!email) {
            this.emailIsValid(e, input);
        } else {
            $(e).find("button[type=submit]").attr("disabled", "disabled");
            const message = $(e).parent().next("span");
            message.show();
            $(input).removeClass("valid").addClass("invalid");
        }
    }

    /* END fishy area */
    emailSubmit(input) {
        //It does not return eventOnSubmit false, instead it returns true which on
        //webpack://[name]_lib/cloudui/libs/jquery-editable/jquery.jeditable.js
        //doesnt let it proceed
        return !input.hasClass('valid');
    }

    emailBlur(e) {
        $(e).parent().next("span").hide();
    }

    urlIsValid(e) {
        const message = $(e).parents().eq(2).next("span");
        message.hide();
        $(e).removeClass("invalid").addClass("valid");

    }

    onTestUrl(data, ev) {
        if (data.outcome && data.outcome === "OK") {
            ev.find("#contactPhoneError").siblings("#contactPhoneError").hide();
        } else {
            ev.find("#contactPhoneError").siblings("#contactPhoneError").show();
        }
    }

    urlIsInvalid(e) {
        const $e = $(e);
        const message = $e.parents().eq(2).next("span");
        if (!$e.val()) {
            return this.urlIsValid(e);
        }
        message.show();
        $e.removeClass("valid").addClass("invalid");
    }

    urlSubmit(input) {
        return !input.hasClass('valid');
    }

    urlBlur(e) {
        $(e).parents().eq(2).next("span").hide();
    }

    async submitNewEmail(email) {
        const oldEmail = this.model.get('email');
        const newEmail = email;
        if (!((oldEmail.trim()) === (newEmail.trim()))) {
            const lng = i18n.language;
            const formValues = {
                oldEmail: oldEmail,
                newEmail: newEmail,
                lng: lng
            };
            try {
                const data = await $.ajaxDefaultQ({
                    url: '/CampaignCloud/CompanyDetails/EmailChangeRequest',
                    type: 'POST',
                    dataType: "json",
                    data: formValues
                });
                if (data["status"] === 'success') {
                    dhtmlx.alert(i18n.t("profile.emailchangerequestsuccess"));
                    this.model.set("pendingConfirmationEmail", newEmail);
                    this.render();
                } else {
                    dhtmlx.alert(i18n.t("register.internalerror"));
                }
            } catch (error) {
                dhtmlx.alert(i18n.t("register.internalerror"));
            }
        }
    }

    @on('click #reject-change')
    async rejectChangeEmail() {
        const url = '/CampaignCloud/CompanyDetails/EmailChangeRequest/RejectEmailChangeRequest';
        try {
            const data = await $.ajaxDefaultQ({
                type: "POST",
                url: url,
                dataType: "json",
            });
            if (data["status"] === 'success') {
                this.model.set("pendingConfirmationEmail", null);
                this.render();
            } else {
                dhtmlx.alert(i18n.t("register.internalerror"));
            }
        } catch (error) {
            dhtmlx.alert(i18n.t("register.internalerror"));
        }
    }
}

export default CompanyDetailsView;